import MessageModal from "../../../../../components/HexModal/MessageModal";
import { getLabel } from "../../../../../hooks/use-labels";
import { useState } from "react";
import {
  emptyCartRequest,
  updateStorageOnClearCart,
} from "../../../../SupplierDetail/ProductDetailModal/ProductDetails/product-cart-detail-utils";
import { updateCart } from "../../../../../redux/reducers/order/order-action";

const ProductUpdatedModal = ({onBack}) => {
  const [loading, setLoading] = useState(false);

  const emptyCart = () => {
    setLoading(true);

    const details = emptyCartRequest();

    updateCart(details).then(() => {
      setLoading(false);
      updateStorageOnClearCart();
      onBack && onBack();
      window.location.reload();
    });
  };

  return (
    <MessageModal
      open={true}
      title={getLabel("productUnavailableLabel")}
      text={getLabel("productUnavailableMessage")}
      onOkay={emptyCart}
      className={"product-update-modal"}
      loading={loading}
    />
  );
};

export default ProductUpdatedModal;
